<template>
  <div class="youdinuan">
    <topTitle title="五有服务" :list="list" :newData="newData"></topTitle>
    <p class="top_p">钱湖柏庭众多兴趣俱乐部、丰富的休闲娱乐场所、俱乐部式的社交平台，让长者的兴趣、爱好与梦想在这里实现，这也是保持年轻的上佳方法。农庄、组团庭院、商业内街与滨水街区、温泉、游泳池，以及铺设地暖的餐厅、电影院、棋牌室、图书馆、音乐室、舞蹈室、书画室、健身运动馆、茶室、咖啡馆等，丰富的公共空间和配套设施...</p>
    <div class="item_bd">
      <img :src="item.img" alt="" v-for="(item,key) in list2" :key='key'>
    </div>
  </div>
</template>
<script>
    import topTitle from "../rightTopTitle";
    export default {
        name: "youshetuan",
        data() {
            return {
                list: [
                    {
                        title: "【五有】有套房",
                        small_title: "HAVE A SUITE",
                        hasTitle: "有套房",
                    },
                    {
                        title: "【五有】有块地",
                        hasTitle: "有块地",
                    },
                    {
                        title: "【五有】有地暖",
                        hasTitle: "有地暖",
                    },
                    {
                        title: "【五有】有社团",
                        small_title: "HAVE A CLUB",
                        hasTitle: "有社团",
                    },
                    {
                        title: "【五有】有管家",
                        small_title: "HAVE A BUTLER",
                        hasTitle: "有管家",
                    }
                ],
                newData:3,
                list2:[{
                    img:require('../../assets/image/index/wenyi.jpg')
                }]
            };
        },
        methods: {},
        mounted: function() {},
        components: {
            topTitle
        },
        props: {

        },
    };
</script>
<style scoped="scoped">
  .youdinuan{
    width: 100%;
    height: 100%;

  }
  .top_p {
    margin-top: 0.6625rem;
    text-align: left;
    font-size: 0.35rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 0.675rem;
    text-indent: 2em;
  }
  .item_bd{
    margin-top: 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item_bd img{
    width:100%;
    /* height: 4.75rem; */
    border-radius: 0.125rem;

  }
</style>